module.exports = __webpack_public_path__ + "static/media/audio.778d2068.jpg";